import moment from 'moment';

export const applyMomentLocale = (lang: string): void => {
    moment.locale(lang || 'en');
};
